import React from "react";
import { useScreenFixedProvider } from "../context/ScreenFixedProvider";
import { Dropdown } from "react-bootstrap";
import LogoImage from "../../assets/img/header/logo.webp";
import {
  HeaderSearchIcon,
  HeaderSearchIcon2,
  HeaderUserIcon,
  HeaderUserIcon2,
} from "./Icons";

const Header = () => {
  const { showOverlay, setShowOverlay } = useScreenFixedProvider();

  return (
    <>
      <section className="d-flex w-100 navbar-wrapper  py-sm-3 py-2">
        <div className="d-lg-flex d-none w-100">
          <div className="d-flex container justify-content-between align-items-center">
            <div>
              <img src={LogoImage} alt="logo-image" />
            </div>
            <div className="d-flex justify-content-center align-items-center">
              <span className="d-inline-block  py-1 px-2 mx-2">
                <li className=" nav-list-items text-dark  d-inline-block ">
                  <a className="  text-black" href="#industries">
                    Industries
                  </a>
                </li>
              </span>

              <span className="d-inline-block  py-1 px-2 mx-2">
                <li className=" nav-list-items text-dark  d-inline-block ">
                  <a className="  text-black" href="#services">
                    Services
                  </a>
                </li>
              </span>

              <span className="d-inline-block  py-1  ps-3">
                <li className=" text-dark   d-inline-block ">
                  <Dropdown>
                    <Dropdown.Toggle id="dropdown-basic">
                      <a
                        className=" text-decoration-none text-black"
                        href="#expertise"
                      >
                        Expertise
                      </a>
                    </Dropdown.Toggle>

                    <Dropdown.Menu className="py-3">
                      <Dropdown.Item className="pb-2">Page 1</Dropdown.Item>
                      <Dropdown.Item className="pb-2">Page 2</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </li>
              </span>

              <span className="d-inline-block  py-1 px-2 mx-2">
                <li className=" nav-list-items text-dark  d-inline-block ">
                  <a className="  text-black" href="#career">
                    Career
                  </a>
                </li>
              </span>

              <span className="d-inline-block  py-1 px-2 mx-2">
                <li className=" nav-list-items text-dark  d-inline-block ">
                  <a className="  text-black" href="#about">
                    About
                  </a>
                </li>
              </span>
              <span className="d-inline-block  py-1 px-2 mx-2">
                <li className=" nav-list-items text-dark  d-inline-block ">
                  <a className="  text-black" href="#Contact">
                    {" "}
                    Contact Us
                  </a>
                </li>
              </span>
            </div>
            <div>
              <HeaderUserIcon />
              <HeaderSearchIcon />
              <button className="common_btn border-0 py-2 px-4 mx-3 btn_hover">
                Buy Now
              </button>
            </div>
          </div>
        </div>
        {/* OVERLAY HERE  THIS CODE RUN BEFORE 992PX*/}
        <div className="d-lg-none d-flex w-100">
          <div className={`${showOverlay ? "overlay-active" : ""} overlay-nav`}>
            <div className="nav-bg-light h-screen d-flex justify-content-center align-items-center">
              <div className="d-flex flex-column text-center ">
                <ul className="p-0">
                  <li className=" transition-0_3sEase overflow-hidden">
                    <span
                      className="py-2 py-sm-4 d-inline-block cursor-pointer"
                      onClick={() => setShowOverlay(false)}
                    >
                      <a
                        href="#industries"
                        className="fs-2 hoverline text-white text-decoration-none"
                      >
                        Industries
                      </a>
                    </span>
                  </li>
                  <li className=" transition-0_3sEase overflow-hidden">
                    <span
                      className="py-2 py-sm-4 d-inline-block cursor-pointer"
                      onClick={() => setShowOverlay(false)}
                    >
                      <a
                        href="#services"
                        className="fs-2 hoverline text-white text-decoration-none"
                      >
                        Services
                      </a>
                    </span>
                  </li>
                  <li className="nav-item btn-img mt-3 mt-lg-1  transition-0_3sEase overflow-hidden">
                    <span
                      className="py-2 py-sm-4 d-inline-block cursor-pointer"
                      onClick={() => setShowOverlay(false)}
                    >
                      <a
                        href="#expertise"
                        className="fs-2 hoverline text-white text-decoration-none"
                      >
                        Expertise
                      </a>
                    </span>
                  </li>
                  <li className="nav-item btn-img mt-3 mt-lg-1  transition-0_3sEase overflow-hidden">
                    <span
                      className="py-2 py-sm-4 d-inline-block cursor-pointer"
                      onClick={() => setShowOverlay(false)}
                    >
                      <a
                        href="#about"
                        className="fs-2 hoverline text-white text-decoration-none"
                      >
                        About
                      </a>
                    </span>
                  </li>
                  <li className="nav-item btn-img mt-3 mt-lg-1  transition-0_3sEase overflow-hidden">
                    <span
                      className="py-2 py-sm-4 d-inline-block cursor-pointer"
                      onClick={() => setShowOverlay(false)}
                    >
                      <a
                        href="#career"
                        className="fs-2 hoverline text-white text-decoration-none"
                      >
                        Career
                      </a>
                    </span>
                  </li>
                  <li className="nav-item btn-img mt-3 mt-lg-1  transition-0_3sEase overflow-hidden">
                    <span
                      className="py-2 py-sm-4 d-inline-block cursor-pointer"
                      onClick={() => setShowOverlay(false)}
                    >
                      <a
                        href="#Contact"
                        className="fs-2 hoverline text-white text-decoration-none"
                      >
                        Contact Us
                      </a>
                    </span>
                  </li>
                  <li className="nav-item btn-img mt-3 mt-lg-1  transition-0_3sEase overflow-hidden">
                    <div>
                      <HeaderUserIcon2 />
                      <HeaderSearchIcon2 />
                      <button className="common_btn border-0 py-2 px-4 mx-3 btn_hover">
                        Buy Now
                      </button>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <nav className="navbar h-86 navbar-expand-lg navbar-light p-3 w-100">
            <div className="d-flex justify-content-between w-100 align-items-center">
              <img src={LogoImage} alt="logo-image" />
              <div
                className={`${
                  showOverlay ? "animate" : ""
                } position-relative navbarwrapper  hamburger-icon d-flex flex-column d-lg-none`}
                onClick={() => setShowOverlay(!showOverlay)}
              >
                <span className="first d-inline-block"></span>
                <span className="second d-inline-block"></span>
                <span className="third d-inline-block"></span>
              </div>
            </div>
          </nav>
        </div>
      </section>
    </>
  );
};

export default Header;
